
export enum RulePosition { 
    current = 'Current', 
    first = 'First',
    last = 'Last'
}